export default "__VITE_ASSET__BgWmzio5__"